(() => {
  const findTarget = () =>
    document.getElementById('nuestro-universo') ||
    document.querySelector('[data-universo-anchor]') ||
    document.querySelector('.chikas-universo-intro-section') ||
    document.querySelector('.chikas-universo-hero-section') ||
    document.querySelector('[id*="universo_intro"]') ||
    document.querySelector('[id*="universo_hero"]');

  const samePageHref = (href) => {
    if (!href || href === '#' || href.startsWith('#')) return true;
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname === window.location.pathname;
    } catch (err) {
      return href.startsWith('#');
    }
  };

  const goToUniverso = (link, e) => {
    const href = link.getAttribute('href') || '';
    const fallback =
      link.getAttribute('data-universo-fallback') ||
      '/pages/sobre-nosotros';

    // Dedicated Sobre nosotros page: navigate normally
    if (!samePageHref(href) || (!href.startsWith('#') && href.includes('/pages/'))) {
      if (e) e.preventDefault();
      window.location.assign(href || fallback);
      return;
    }

    if (e) e.preventDefault();
    const target = findTarget();
    if (target) {
      const top =
        target.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
      });
      try {
        history.replaceState(null, '', '#nuestro-universo');
      } catch (err) {}
      return;
    }

    window.location.assign(fallback);
  };

  document.addEventListener(
    'click',
    (e) => {
      const link = e.target.closest('[data-chikas-universo-cta]');
      if (!link) return;
      goToUniverso(link, e);
    },
    true
  );

  const boot = () => {
    if (location.hash !== '#nuestro-universo') return;
    const target = findTarget();
    if (!target) return;
    requestAnimationFrame(() => {
      const top =
        target.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
